import { StudentService } from '../../_services/student.service';
import { DataUtilService } from '../../_services/data-util.service';
import { Component, OnInit,Input } from '@angular/core';

@Component({
  selector: 'app-score-summary',
  templateUrl: './score-summary.component.html',
  styleUrls: ['./score-summary.component.css']
})
export class ScoreSummaryComponent implements OnInit {
  @Input() studentUserId=0
  scoreSummary={latestaveragethree:0,lastscore:0}
  constructor(private studentService:StudentService, private dataUtilService:DataUtilService) { }

  ngOnInit(): void {

  this.studentService.studentSubject.subscribe(
  data =>{
    if(data!=null){
      if(data['server_user_id']!=0){
        this.studentUserId=data['server_user_id']
        this.getScoreSummary(this.studentUserId)
       }
      // if(this.dataUtilService.isGoodResponse(data)){
      //   //let student= this.dataUtilService.myData(data)

      //  }
    }

  }
);
}
getScoreSummary(studentUserId:number){
  this.studentService.getScoreSummary(studentUserId).subscribe(
    data =>{
      if(this.dataUtilService.isGoodResponse(data)){
       this.scoreSummary= this.dataUtilService.myData(data)
      }
    }
  );
}
}
